import { useMutation, useQueryClient } from "@tanstack/react-query";
import { catalogSubscriptionPlansService } from "@/services/catalog-subscription-plans-service";
import {
  CreateSubscriptionPlanPayload,
  UpdateSubscriptionPlanPayload,
} from "@/types/subscription-plan";
import { subscriptionPlanKeys } from "./useSubscriptionPlans";

export const useCreateCustomPlan = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      tenantId,
      payload,
    }: {
      tenantId: string;
      payload: CreateSubscriptionPlanPayload;
    }) => catalogSubscriptionPlansService.createCustomPlan(tenantId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: subscriptionPlanKeys.all });
    },
  });
};

export const useCreateSubscriptionPlan = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateSubscriptionPlanPayload) =>
      catalogSubscriptionPlansService.createPlan(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: subscriptionPlanKeys.all });
    },
  });
};

export const useUpdateSubscriptionPlan = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: UpdateSubscriptionPlanPayload;
    }) => catalogSubscriptionPlansService.updatePlan(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: subscriptionPlanKeys.all });
    },
  });
};

export const useDeleteSubscriptionPlan = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => catalogSubscriptionPlansService.deletePlan(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: subscriptionPlanKeys.all });
    },
  });
};
